import { initialMasterDropdownsState } from "./MasterDropdowns.types";
import { LoadState } from "../../constants/enums";
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchMasterDropdownOptions,
  fetchMasterDropdownsList,
} from "./MasterDropdownsActions";

const masterDropdownSlice = createSlice({
  name: "masterDropdowns",
  initialState: initialMasterDropdownsState,
  reducers: {
    clearMasterDropdownsState: (state) => {
      return initialMasterDropdownsState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMasterDropdownsList.pending, (state) => {
        state.data.loading = LoadState.InProgress;
        state.data.list = [];
      })
      .addCase(fetchMasterDropdownsList.fulfilled, (state, action) => {
        state.data.loading = LoadState.Loaded;
        state.data.list = action.payload.data;
      })
      .addCase(fetchMasterDropdownsList.rejected, (state) => {
        state.data.loading = LoadState.Failed;
        state.data.list = [];
      })
      .addCase(fetchMasterDropdownOptions.pending, (state, action) => {
        if (!state.runtimeRefData[action.meta.arg]) {
          state.runtimeRefData[action.meta.arg] = {
            list: [],
          };
        }
      })
      .addCase(fetchMasterDropdownOptions.fulfilled, (state, action) => {
        state.runtimeRefData[action.payload.dropdownCode].list =
          action.payload.options;
      });
  },
});

export const { clearMasterDropdownsState } = masterDropdownSlice.actions;
export const MasterDropdownsReducer = masterDropdownSlice.reducer;
